module.exports = __webpack_public_path__ + "img/LTS_ABSA.be9ef2f7.gif";